import type { Route } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';

import { AuthFailureGuard, AuthLogoutGuard /*, AuthTokenRefreshGuard*/ } from '@evc/platform';
import type { ImportAsyncComponent } from '@shared/types/utils.type';

const importPageNotFoundComponent: ImportAsyncComponent = () =>
  import('@shared/components/page-not-found/page-not-found.component').then(
    (m) => m.PageNotFoundComponent,
  );

export const authGuards = [
  MsalGuard /*, AuthTokenRefreshGuard*/,
];

export const appRoutes: Route[] = [
  {
    path: 'logout',
    canActivate: [AuthLogoutGuard],
    loadComponent: importPageNotFoundComponent,
    data: { logout: true },
  },
  {
    path: 'auth-fail',
    canActivate: [AuthFailureGuard],
    loadComponent: importPageNotFoundComponent,
  },
  {
    path: '',
    pathMatch: 'full',
    loadComponent: () => import('./pages/users/users.component').then((m) => m.PageUsersComponent),
    canActivate: authGuards,
  },
  {
    path: 'licenses',
    loadComponent: () =>
      import('./pages/licenses/applications/applications.component').then(
        (m) => m.PageApplicationsComponent,
      ),
    canActivate: authGuards,
  },
  {
    path: 'licenses/:productId',
    loadComponent: () =>
      import('./pages/licenses/application-licenses/application-licenses.component').then(
        (m) => m.PageApplicationLicensesComponent,
      ),
    canActivate: authGuards,
  },
  {
    path: 'linked-organizations',
    loadComponent: () =>
      import('./pages/linked-orgs/linked-orgs.component').then((m) => m.PageLinkedOrgsComponent),
    canActivate: authGuards,
  },
  {
    path: 'organization-settings',
    loadComponent: () =>
      import('./pages/org-settings/org-settings.component').then((m) => m.PageOrgSettingsComponent),
    canActivate: authGuards,
  },
  {
    path: '**',
    loadComponent: importPageNotFoundComponent,
    canActivate: authGuards,
  },
];
